import Accordion from 'accordion/src/accordion.mjs';

const CLASSNAME_ENABLED = 'accordion--enabled';

class DefaultAccordion {
  constructor(options = {}) {
    this.element = options.element;
    this.heightOffset = this.element.dataset.heightOffset || null;
    this.withMedia = this.element.dataset.withMedia || false;
    this.classNameContent = this.element.dataset.classNameContent || 'org--accordion__content';

    this.initialized = false;
  }

  init() {

    const initAccordion = () => {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      if (this.withMedia) {
        // accordion items containing images or videos require a timeout to accurately calculate their height
        window.setTimeout(() => this.createAccordion(), 1000);
      } else {
        this.createAccordion();
      }
    };

    initAccordion();

    // if an accordion is behind an access restriction -> event from AccessRestriction\index.js
    document.addEventListener('access:revealed', () => {
      this.initialized = false;
      initAccordion();
    });
  }

  createAccordion() {
    const content = this.element.querySelector(`.${this.classNameContent}`);

    // eslint-disable-next-line no-new
    new Accordion(content, {
      enabledClass: CLASSNAME_ENABLED,
      modal: true,
      noAria: false,
      heightOffset: this.heightOffset,
    });
  }
}

export default DefaultAccordion;
